import React from "react";

const styles = {
    stack: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        padding: "12px",
        pointerEvents: "none",
    },
    card: {
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        minWidth: "140px",
        padding: "10px 12px",
        borderRadius: "12px",
        border: "1px solid rgba(255, 255, 255, 0.08)",
        background:
            "linear-gradient(180deg, rgba(12, 19, 38, 0.92), rgba(7, 12, 26, 0.96))",
        boxShadow:
            "0 12px 36px rgba(0, 0, 0, 0.24), inset 0 1px 0 rgba(255, 255, 255, 0.05)",
    },
    label: {
        fontSize: "11px",
        fontWeight: 800,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        color: "#7dd3fc",
        fontFamily:
            'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
    },
    value: {
        fontSize: "16px",
        fontWeight: 800,
        lineHeight: 1.2,
        color: "#f8fafc",
    },
    row: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "12px",
        color: "#dbeafe",
        fontSize: "12px",
        lineHeight: 1.4,
    },
    dim: {
        color: "#94a3b8",
    },
    list: {
        display: "flex",
        flexDirection: "column",
        gap: "4px",
    },
};

export function SceneOverlayStack({ children }) {
    return <div style={styles.stack}>{children}</div>;
}

export function SceneOverlayCard({ label, value, children, minWidth = 140 }) {
    return (
        <div style={{ ...styles.card, minWidth }}>
            {label ? <div style={styles.label}>{label}</div> : null}
            {value !== undefined && value !== null ? (
                <div style={styles.value}>{value}</div>
            ) : null}
            {children}
        </div>
    );
}

export function SceneOverlayRow({ label, value, dim = false }) {
    return (
        <div style={{ ...styles.row, ...(dim ? styles.dim : null) }}>
            <span>{label}</span>
            <span>{value}</span>
        </div>
    );
}

export function SceneOverlayList({ items = [], emptyLabel = "-" }) {
    return (
        <div style={styles.list}>
            {items.length === 0 ? (
                <div style={{ ...styles.row, ...styles.dim }}>
                    <span>{emptyLabel}</span>
                </div>
            ) : (
                items.map((item, index) => (
                    <div key={`${item}-${index}`} style={styles.row}>
                        <span>{item}</span>
                    </div>
                ))
            )}
        </div>
    );
}